import Vue from "vue";
import axios from "axios";

function sanitizeAbn(abn) {
  return String(abn || "").replace(/\s/g, "");
}

export const entsiaFunctions = new Vue({
  methods: {
    // async authenticate(method, data) {
    //   var resp = await this.postData("/crud/customer-lc-policy", {
    //     method,
    //     data
    //   });
    //   return resp.data;
    // }

    // async acceptPSQuote(formModel) {
    //   console.log(formModel);
    //   var resp = await this.postData("/live/acceptPSQuote", formModel);
    //   return resp.data;
    // },
    // async getFormInitData() {
    //   var resp = await this.getData("/live/getFormInitData");
    //   return resp.data;
    // },
    async requestQuote(body) {
      var resp = await this.postData("/live/motor/requestQuote",body);
      return resp.data;
    },
    async updateQuote(body) {
      var resp = await this.postData("/live/motor/updateQuote",body);
      return resp.data;
    },
    async acceptReferralTerms(body) {
      var resp = await this.postData("/live/motor/acceptReferralTerms",body);
      return resp.data;
    },
    async sendPartnerEmail(model, template, sendToPartner = true, sendToCustomer = true, customerTemplate = null) {
      var resp = await this.postData("/live/motor/sendPartnerEmail", {
        model,
        template,
        sendToPartner,
        sendToCustomer,
        customerTemplate
      });
      return resp.data;
    },
    /** No auth header — same as continue-quote flow where customers may not be logged in as broker. */
    async updateMotorQuoteStatusByGuid(policy_guid, status) {
      const base = (process.env.VUE_APP_APIENDPOINT || "").replace(/\/$/, "");
      if (!base) {
        const err = new Error("VUE_APP_APIENDPOINT is not set");
        console.error(err);
        throw err;
      }
      var resp = await axios.post(
        `${base}/live/motor/updatePolicyStatusByGuid`,
        { policy_guid, status }
      );
      return resp.data;
    },
    /** No auth header — used when a customer submits referred/declined underwriting answers. */
    async submitMotorUnderwritingInformation(policy_guid, status, model) {
      const base = (process.env.VUE_APP_APIENDPOINT || "").replace(/\/$/, "");
      if (!base) {
        const err = new Error("VUE_APP_APIENDPOINT is not set");
        console.error(err);
        throw err;
      }
      var resp = await axios.post(
        `${base}/live/motor/submitUnderwritingInformation`,
        { policy_guid, status, model }
      );
      return resp.data;
    },
    /** No auth header — proxies Cloudfloat quote request through the backend so the API key stays server-side. */
    async requestCloudfloatQuote(annualPremiumInCents, customer = {}, policy_guid = "") {
      const base = (process.env.VUE_APP_APIENDPOINT || "").replace(/\/$/, "");
      if (!base) {
        const err = new Error("VUE_APP_APIENDPOINT is not set");
        console.error(err);
        throw err;
      }
      var resp = await axios.post(`${base}/live/motor/cloudfloatQuote`, {
        policy_guid,
        annual_premium_in_cents: annualPremiumInCents,
        abn: sanitizeAbn(customer.abn),
        first_name: customer.first_name || "",
        middle_name: customer.middle_name || "",
        last_name: customer.last_name || "",
        email: customer.email || "",
        phone: customer.phone || ""
      });
      return resp.data;
    },
    async saveMotorCloudfloatQuote(policy_guid, cloudfloatQuote) {
      const base = (process.env.VUE_APP_APIENDPOINT || "").replace(/\/$/, "");
      if (!base) {
        const err = new Error("VUE_APP_APIENDPOINT is not set");
        console.error(err);
        throw err;
      }
      var resp = await axios.post(`${base}/live/motor/saveCloudfloatQuote`, {
        policy_guid,
        cloudfloatQuote
      });
      return resp.data;
    },
    // async updateQuote(body) {
    //   var resp = await this.postData("/live/updateQuote",body);
    //   return resp.data;
    // },
    // async updateQuotePublic(body) {
    //   var resp = await this.postDataPublic("/lookup/updatePSQuote",body);
    //   return resp.data;
    // },
    // async getUpdatedPeriodOfCover(dateString) {
    //   var resp = await this.getData("/live/getUpdatedPeriodOfCover?date=" + dateString);
    //   return resp.data;
    // },
    // async changeInceptionDate(dateString) {
    //   var resp = await this.postData("/live/requestQuote",body);
    //   return resp.data;
    // },
    getData(url) {
      let config = {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token")
        }
      };

      return axios.get(process.env.VUE_APP_APIENDPOINT + url, config);
    },
    postData(url, body) {
      let config = {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token")
        }
      };

      return axios.post(process.env.VUE_APP_APIENDPOINT + url, body, config);
    },
    // postDataPublic(url, body) {
    //   let config = {
    //     // headers: {
    //     //   Authorization: "Bearer " + sessionStorage.getItem("token")
    //     // }
    //   };

    //   return axios.post(process.env.VUE_APP_APIENDPOINT + url, body, config);
    // },
  }

})